import Panel from './src/panel'

export default Panel


// WEBPACK FOOTER //
// ./src/components/tofu-panel/index.js